const alphabet = [
    0,"A","B","C","D","E","F","G","H","I","J","K"
];

export default (number, filter, filterAllowed) => {
    if (typeof number === 'object' && number.length > 0) {
        let newNumber = [];
        for (let index = 0; index < number.length; index++) {
            if (alphabet[number[index]]) newNumber.push(alphabet[number[index]]);
        }
        return newNumber;
    } else if (typeof number === 'number') {
        return filterAllowed.find(filterAllowedName => filterAllowedName === filter) && alphabet[number] ? alphabet[number] : number;
    } else {
        return [];
    }
    
}